import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAdminRamUser } from '../../../actions/userActions';
import { MultiSelectFilter } from './MultiSelectFilter';
import { peopleOptions } from './peopleOptions';

/** RAM owner filter, over the admin RAM users. */
export const RamFilter = ({
  filter,
  handleFilterChange,
  label = 'RAM',
  unassignedLabel = 'Unassigned',
}) => {
  const dispatch = useDispatch();
  const ramList = useSelector((state) => state.users.ramUsers);

  useEffect(() => {
    if (!ramList) {
      dispatch(getAdminRamUser());
    }
  }, [dispatch, ramList]);

  return (
    <MultiSelectFilter
      label={label}
      options={peopleOptions(ramList, unassignedLabel)}
      value={filter?.ram}
      onChange={(value) => handleFilterChange('ram', value)}
    />
  );
};

export default RamFilter;
